/*
 * tnxi-switch.js — profile switcher for sections/tnxi-profile-switcher.liquid.
 * Hover/click a profile in the left (PFD) or right (MFD/Navigator) list and its
 * clip/screenshot fades in over the matching unit on the base image. The last
 * hovered/clicked profile in each group stays shown (works on touch too).
 */
(function () {
  'use strict';

  function initSwitcher(root) {
    var slots = {
      pfd: root.querySelector('[data-slot="pfd"]'),
      mfd: root.querySelector('[data-slot="mfd"]')
    };

    function activate(btn) {
      var group = btn.getAttribute('data-group');
      var id = btn.getAttribute('data-profile');
      var slot = slots[group];
      if (!slot) return;

      root.querySelectorAll('[data-group="' + group + '"]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });

      slot.querySelectorAll('[data-media]').forEach(function (m) {
        var on = m.getAttribute('data-media') === id;
        m.classList.toggle('is-active', on);
        var v = m.querySelector('video');
        if (v) {
          if (on) {
            try { v.currentTime = 0; } catch (e) {}
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        }
      });
    }

    root.querySelectorAll('[data-profile]').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () { activate(btn); });
      btn.addEventListener('focus', function () { activate(btn); });
      btn.addEventListener('click', function (e) { e.preventDefault(); activate(btn); });
    });

    // Default: first profile of each group.
    ['pfd', 'mfd'].forEach(function (g) {
      var first = root.querySelector('[data-group="' + g + '"]');
      if (first) activate(first);
    });
  }

  document.querySelectorAll('[data-tnxi-switch]').forEach(initSwitcher);
})();
